import React, { useState, useEffect, useRef, useMemo } from 'react';
import sliderArrow from '../../assets/images/institute/slider-arrow.svg';
import Accordion from 'react-bootstrap/Accordion';
import Footer1 from '../Common/Footer1/Footer1';
import Header1 from '../Common/Header1/Header1';
import clientTestimonial from '../../assets/video/test.mp4';
import titlestar from '../../assets/images/institute/title-star.svg';
import quote from '../../assets/images/institute/quote.png';
import thumbnailRyan from '../../assets/images/home/thumbnail_Ryan.png';
import thunderImage from '../../assets/images/institute/thunderImage.png';
import instituteHeroMobile from '../../assets/images/institute/instituteHeroMobile.png';
import instituteHero from '../../assets/images/institute/instituteHero.png';
import fist from '../../assets/images/institute/fist.png';
import add from '../../assets/images/institute/add.png';
import subtract from '../../assets/images/institute/subtract.png';
import AdmissionsCard from '../../assets/images/institute/AdmissionsCard.png';
import FeeManagementCard from '../../assets/images/institute/FeeManagementCard.png';
import PaymentsCard from '../../assets/images/institute/PaymentsCard.png';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import 'swiper/css';
import './Institute.css';
import classes from './Card.module.scss';
import ryanInsititueLogo from '../../assets/images/institute/mask2.png';
import podarInstituteLogo from '../../assets/images/institute/podarInstituteLogo.png';
import { SEO } from '../seo';
import {
    Admissions,
    FeeManagement,
    OtherSolutionCards,
    Payments,
} from '../molecules/InstituteContent';
import { VectorDesktop, VectorMobile } from '../atoms/Icons/Icons';
import { CustomImage, CustomTabSwitcher } from '../atoms';

function Institue() {
    const swiperRef = useRef();
    const navigate = useNavigate();
    const [hideRightArrow, setHideRightArrow] = useState(false);
    const [help1, setHelp1] = useState(false);
    const [help2, setHelp2] = useState(false);
    const [help3, setHelp3] = useState(false);
    const [help4, setHelp4] = useState(false);
    const [help5, setHelp5] = useState(false);
    const [help6, setHelp6] = useState(false);
    const [activeTab, setActiveTab] = useState('Admissions');

    const tabItems = ['Admissions', 'Fee Management', 'Payments'];

    const renderTabContent = () => {
        switch (activeTab) {
            case 'Admissions':
                return <Admissions />;
            case 'Fee Management':
                return <FeeManagement />;
            case 'Payments':
                return <Payments />;
            default:
                return null;
        }
    };

    const sliderSettings = {
        0: {
            slidesPerView: 1,
        },
        425: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        1024: {
            slidesPerView: 1.3,
            spaceBetween: 20,
        },
    };

    const otherSolutionCardOptions = [
        {
            id: 'Admissions',
            title: 'Admissions',
            description: 'Admissions Software that adapts to you',
            imageUrl: AdmissionsCard,
            imagePosition: classes.AdmissionCard,
        },
        {
            id: 'Fee Management',
            title: 'Fee Management',
            description:
                'A smart SAAS platform for fee collection and parent communication',
            imageUrl: FeeManagementCard,
            imagePosition: classes.FeeManagementCard,
        },
        {
            id: 'Payments',
            title: 'Payments',
            description: 'All-in-one powerful fee payment solution',
            imageUrl: PaymentsCard,
            imagePosition: classes.PaymentsCard,
        },
    ].filter((item) => item.id !== activeTab);

    const handleTabChange = (id) => {
        setActiveTab(id);
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <SEO pageName="institute">
            <div className='institues institute parents instituteStyle'>
                <Header1 theme={'institute'} />
                <section className='bg--blue pb-0 hero institute'>
                    <div className='instituteContainer'>
                        <div className=''>
                            <h1 className='text--bold section__title-1 text-center text-white bannerHeading'>
                                From admissions to analytics,{' '}
                                <span className='text--pinkGradient'>
                                    tailored
                                </span>{' '}
                                solution for your institue
                            </h1>
                            <div className='hero_wrapper'>
                                <img
                                    className='hero_image'
                                    src={window.innerWidth <= 468 ? instituteHeroMobile : instituteHero}
                                    alt='Institute management platform for educational institutions'
                                    loading="eager"
                                    fetchpriority="high"
                                />
                            </div>
                        </div>
                    </div>
                </section>
                <div className='ourSolutionsContainer'>
                    <div className='ourSolutionsText'>
                        <h1>
                            Our{' '}
                            <span className='text--blueGradient'>
                                Solutions
                            </span>{' '}
                        </h1>
                    </div>
                    <span className='vectorDesktop'>
                        <VectorDesktop />
                    </span>
                    <span className='vectorMobile'>
                        <VectorMobile />
                    </span>
                    <div className='tabSwitcherContainer'>
                        <CustomTabSwitcher
                            tabList={tabItems}
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                        {activeTab === 'Admissions' && (
                            <div className='newbadge'>
                                <span className='newText'>new!</span>
                            </div>
                        )}
                    </div>
                </div>
                <div className='tab-content-wrapper'>
                    <div key={activeTab} className='tab-content slide-in'>
                        {renderTabContent()}
                    </div>
                </div>

                {/* Other Solutions Cards */}
                <div className='otherSolutionsCard'>
                    <div className='headingWrapper'>
                        <div className='otherSolutionWrapper'>
                            <img src={titlestar} className='star' alt='star' />
                            <span className='otherSolutionText'>
                                OTHER SOLUTIONS
                            </span>
                            <span className='springTop' />
                        </div>
                        <div className='checkMeOut'>Check ‘em out</div>
                    </div>
                    <div className='solutionCardsWrapper'>
                        {otherSolutionCardOptions.map((card) => (
                            <OtherSolutionCards
                                key={card.id}
                                id={card.id}
                                title={card.title}
                                description={card.description}
                                imageUrl={card.imageUrl}
                                imagePosition={card.imagePosition}
                                onClick={() => handleTabChange(card.id)}
                            />
                        ))}
                    </div>
                </div>

                <section className='bg--blue pb--0 collectManageSection'>
                    <div className='container'>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <img src={thunderImage} />
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '20px',
                            }}
                        >
                            <h2 className='text--bold blue-section-title collectmanagehead'>
                                <span className='text--pinkGradient collectmanage'>
                                    {' '}
                                    Collect & manage
                                </span>{' '}
                                with India’s most loved fee payments
                                <span className='platformTxt'> platform</span>
                            </h2>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '20px',
                            }}
                        >
                            <h4
                                style={{
                                    width: '540px',
                                    fontFamily: 'NunitoSans-Regular',
                                    fontSize: '22px',
                                    fontWeight: 'normal',
                                    fontStretch: 'normal',
                                    fontStyle: 'normal',
                                    lineHeight: '1.27',
                                    letterSpacing: 'normal',
                                    textAlign: 'center',
                                    color: 'rgba(255, 255, 255, 0.8)',
                                }}
                            >
                                A combination of ARC and RAPID ensure an
                                advanced, stand out platform for your institute.
                            </h4>
                        </div>
                        <div
                            style={{
                                textAlign: 'center',
                                marginTop: '30px',
                            }}
                        >
                            <a
                                className='custom__btn custom__btn--white'
                                onClick={() => navigate('/contact')}
                                style={{
                                    textDecoration: 'none',
                                }}
                            >
                                Schedule demo
                            </a>
                        </div>
                    </div>
                </section>
                <section className='bg--lightGray testimonial fellowParentsSection'>
                    <div className='container'>
                        <div className='testimonial__heading'>
                            <h2 className='section__title-1 mx-0 text--bold text--black'>
                                Hear it from our{' '}
                                <span className='text--blueGradient'>
                                    fellow partners
                                </span>
                            </h2>
                            <img
                                className='img-fluid'
                                src={fist}
                                alt='testimonial icon'
                            />
                        </div>
                    </div>

                    <div className='HomePageSlider'>
                        <Swiper
                            id='slider_margin'
                            className='testimonial__slider'
                            onBeforeInit={(swiper) => {
                                swiperRef.current = swiper;
                            }}
                            centeredSlides={true}
                            breakpoints={sliderSettings}
                            onSlideChange={(e) =>
                                e.activeIndex === 1
                                    ? setHideRightArrow(true)
                                    : setHideRightArrow(false)
                            }
                        >
                            <SwiperSlide>
                                <div className='HomePageSlider__Slide'>
                                    <div className='Slide__MediaWrap HasVideo'>
                                        <div className='VideoWrap'>
                                            <video
                                                width='100%'
                                                height='100%'
                                                controls
                                                poster={thumbnailRyan}
                                            >
                                                <source
                                                    src={clientTestimonial}
                                                    type='video/mp4'
                                                />
                                                Your browser does not support
                                                HTML video.
                                            </video>
                                        </div>
                                    </div>

                                    <div className='Slide__ContentWrap'>
                                        <img
                                            className='InstituteLogoImage'
                                            src={ryanInsititueLogo}
                                            alt='institute'
                                        />
                                        <img
                                            className='QuoteImage'
                                            src={quote}
                                            alt=''
                                        />
                                        <p className='ContentText'>
                                            GQ has proven to be fantastic at our
                                            school. Fee collection became super
                                            easy. Also, we love using their
                                            dashboard.
                                        </p>

                                        <div className='Author'>
                                            <p className='Name'>
                                                Mr Ryan Pinto
                                            </p>
                                            <p className='Designation'>
                                                CEO, Ryan International Group
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='HomePageSlider__Slide'>
                                    <div className='Slide__ContentWrap'>
                                        <img
                                            className='InstituteLogoImage'
                                            src={podarInstituteLogo}
                                            alt='institute'
                                        />
                                        <img
                                            className='QuoteImage'
                                            src={quote}
                                            alt=''
                                        />
                                        <p className='ContentText'>
                                            Podar Education Network has always
                                            supported startup initiatives - if
                                            they truly add value to our
                                            ecosystem of 100+ schools. It was
                                            with this spirit that we decided to
                                            pilot GrayQuest's product in 3 of
                                            our schools more than 5 years ago
                                            when we first heard about their
                                            concept - becoming their 1st school
                                            customer. Since the pilot, we have
                                            seen GQ grow multifold in terms of
                                            their product capability, service
                                            and eventually impact on not just
                                            Podar Group but the broader Indian
                                            education ecosystem.
                                        </p>

                                        <div className='Author'>
                                            <p className='Name'>Adhar Samria</p>
                                            <p className='Designation'>
                                                CFO Podar Education Network
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>

                    <div className='container'>
                        <div className='slider-controls'>
                            <a
                                style={{ cursor: 'pointer' }}
                                className='slider-arrow btn-prev review-swiper-button-next'
                            >
                                <img
                                    onClick={() =>
                                        swiperRef.current?.slidePrev()
                                    }
                                    className='img-fluid'
                                    src={sliderArrow}
                                    alt='slider arrow'
                                />
                                <span className='sr-only'>Prev Btn</span>
                            </a>

                            {!hideRightArrow ? (
                                <a
                                    style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                        swiperRef.current?.slideNext()
                                    }
                                    className='slider-arrow btn-next'
                                >
                                    <img
                                        className='img-fluid'
                                        src={sliderArrow}
                                        alt='slider arrow'
                                    />
                                    <span className='sr-only'>Next Btn</span>
                                </a>
                            ) : null}
                        </div>
                    </div>
                </section>
                <section className='bg--withPadding faq'>
                    <div className='container'>
                        <h2 className='section__title-1 text--bold text-center mb-3'>
                            We’re here to{' '}
                            <span className='text--blueGradient'>help you</span>
                        </h2>
                        <p className='section__desc text--regular text--black text-center'>
                            These questions will help clear some of your doubts
                            But if they don’t, we are also just a call away!
                        </p>
                        <div className='faq__container'>
                            <Accordion>
                                <Accordion.Item
                                    className='faq__card'
                                    eventKey='0'
                                >
                                    <Accordion.Header
                                        onClick={() => setHelp1(!help1)}
                                        className='faq__header collapsed'
                                    >
                                        <p className='text--bold text--black'>
                                            What solutions does GQ offer to
                                            Educational Institutions?
                                        </p>
                                        {!help1 ? (
                                            <img
                                                className='img-fluid'
                                                src={add}
                                                alt='dummy institute'
                                            />
                                        ) : (
                                            <img
                                                className='img-fluid'
                                                src={subtract}
                                                alt='dummy institute'
                                            />
                                        )}
                                    </Accordion.Header>
                                    <Accordion.Body
                                        className='faq__answer'
                                        id='question_1'
                                    >
                                        <p className='text--regular faq__answerTxt '>
                                            GQ offers a range of payment
                                            solutions to boost fee collection
                                            for educational institutions.
                                            Essentially, we offer 3 payment
                                            options - EMI, Auto-Debit Payments
                                            and Online Payment Gateway
                                            Solutions. These payment options are
                                            available on our unified
                                            consolidated payments platform
                                            called Rapid. Educational
                                            institutions can activate the 1 or
                                            all of the payment options as per
                                            their requirements.
                                        </p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item
                                    className='faq__card'
                                    eventKey='1'
                                >
                                    <Accordion.Header
                                        onClick={() => setHelp2(!help2)}
                                        className='faq__header collapsed'
                                    >
                                        <p className='text--bold text--black'>
                                            Can GQ’s payment solutions integrate
                                            with an educational institution’s
                                            existing ERP platform?
                                        </p>
                                        {!help2 ? (
                                            <img
                                                className='img-fluid'
                                                src={add}
                                                alt='dummy institute'
                                            />
                                        ) : (
                                            <img
                                                className='img-fluid'
                                                src={subtract}
                                                alt='dummy institute'
                                            />
                                        )}
                                    </Accordion.Header>
                                    <Accordion.Body
                                        className='faq__answer'
                                        id='question_2'
                                    >
                                        <p className='text--regular'>
                                            Yes, All of GQ’s payment solutions
                                            can integrate seamlessly with an
                                            educational institution’s existing
                                            ERP platform, just like any other
                                            payment gateway. The integration
                                            will ensure all payments processed
                                            through GQ platform are
                                            automatically updated and reconciled
                                            with the Institute’s ERP platform.
                                        </p>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item
                                    className='faq__card'
                                    eventKey='3'
                                >
                                    <Accordion.Header
                                        onClick={() => setHelp3(!help3)}
                                        className='faq__header collapsed'
                                    >
                                        <p className='text--bold text--black'>
                                            Our Educational Institution does not
                                            have an ERP? Can we still use GQ’s
                                            payment solutions?
                                        </p>
                                        {!help3 ? (
                                            <img
                                                className='img-fluid'
                                                src={add}
                                                alt='dummy institute'
                                            />
                                        ) : (
                                            <img
                                                className='img-fluid'
                                                src={subtract}
                                                alt='dummy institute'
                                            />
                                        )}
                                    </Accordion.Header>
                                    <Accordion.Body
                                        className='faq__answer'
                                        id='question_3'
                                    >
                                        <p className='text--regular'>
                                            Yes, GQ also provides it’s own fee
                                            management platform called Arc,
                                            which can be used by educational
                                            institutions to store, track, manage
                                            and collect fees for all their
                                            students. Payments collected outside
                                            GQ’s payment platforms can also be
                                            updated in the software. This is a
                                            state of the art offering, which
                                            also enables institutes to send
                                            automated reminders (on whatsapp,
                                            SMS, email) to overdue
                                            students/parents.
                                        </p>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item
                                    className='faq__card'
                                    eventKey='4'
                                >
                                    <Accordion.Header
                                        onClick={() => setHelp4(!help4)}
                                        className='faq__header collapsed'
                                    >
                                        <p className='text--bold text--black'>
                                            How does GQ’s EMI payment solution
                                            work? What are the benefits to
                                            educational institutions and
                                            parents?
                                        </p>
                                        {!help4 ? (
                                            <img
                                                className='img-fluid'
                                                src={add}
                                                alt='dummy institute'
                                            />
                                        ) : (
                                            <img
                                                className='img-fluid'
                                                src={subtract}
                                                alt='dummy institute'
                                            />
                                        )}
                                    </Accordion.Header>
                                    <Accordion.Body
                                        className='faq__answer'
                                        id='question_4'
                                    >
                                        <p className='text--regular'>
                                            Our EMI platform enables
                                            parents/students to convert their
                                            annual/term fees into easy monthly
                                            installments. Institutes can choose
                                            to offer this EMI at Zero Extra Cost
                                            to their parents and in turn receive
                                            the entire annual fee upfront from
                                            GQ on behalf of their parents. Hence
                                            parents get the convenience of
                                            monthly payments while institutions
                                            can receive their entire year’s fee
                                            upfront in lumpsum - ensuring a true
                                            win-win!
                                        </p>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item
                                    className='faq__card'
                                    eventKey='5'
                                >
                                    <Accordion.Header
                                        onClick={() => setHelp5(!help5)}
                                        className='faq__header collapsed'
                                    >
                                        <p className='text--bold text--black'>
                                            How does GQ’s Auto-Debit Platform
                                            work? What are the benefits to
                                            educational institutions and
                                            parents?
                                        </p>
                                        {!help5 ? (
                                            <img
                                                className='img-fluid'
                                                src={add}
                                                alt='dummy institute'
                                            />
                                        ) : (
                                            <img
                                                className='img-fluid'
                                                src={subtract}
                                                alt='dummy institute'
                                            />
                                        )}
                                    </Accordion.Header>
                                    <Accordion.Body
                                        className='faq__answer'
                                        id='question_5'
                                    >
                                        <p className='text--regular'>
                                            In most cases, parents have to pay
                                            fees to their educational
                                            institution on a recurring basis
                                            (every quarter/semester/term). GQ
                                            has created a first of its kind Auto
                                            Debit platform, where institutions
                                            can configure their fee installment
                                            schedule. Once parents register for
                                            Auto-Debit, the fees as per the
                                            institution’s fee installment
                                            schedule will be automatically
                                            deducted from the parent’s
                                            registered bank account on the due
                                            date - saving both the institution
                                            the hassle of follow ups and the
                                            parents the hassle of remembering
                                            the due dates to pay their fee.
                                        </p>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item
                                    className='faq__card'
                                    eventKey='6'
                                >
                                    <Accordion.Header
                                        onClick={() => setHelp6(!help6)}
                                        className='faq__header collapsed'
                                    >
                                        <p className='text--bold text--black'>
                                            How does GQ’s online payment
                                            platform work?
                                        </p>
                                        {!help6 ? (
                                            <img
                                                className='img-fluid'
                                                src={add}
                                                alt='dummy institute'
                                            />
                                        ) : (
                                            <img
                                                className='img-fluid'
                                                src={subtract}
                                                alt='dummy institute'
                                            />
                                        )}
                                    </Accordion.Header>
                                    <Accordion.Body
                                        className='faq__answer'
                                        id='question_6'
                                    >
                                        <p className='text--regular'>
                                            Our online Payment platform enables
                                            institutions to collect fees from
                                            parents via UPI, Debit Cards, Credit
                                            Cards, Net Banking and other popular
                                            online payment modes.
                                        </p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </div>
                </section>
            </div>
        </SEO>
    );
}

export default Institue;
